/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import Backbone from 'backbone';

import GetAWPackage from '../services/GetAWPackage';
import GetAWPAttachments from '../services/GetAWPAttachments';
import GetOrderDocumentTypes from '../../order/services/GetOrderDocumentTypes';
import GetAWPDocumentTypes from '../services/GetAWPDocumentTypes';
import AWPackageAttachmentsView from '../views/AWPackageAttachmentsView';

export default async function loadAWPackageAttachmentsView({ awPackageId, editable }) {
  const awPackage = await GetAWPackage(awPackageId);

  const [attachments, documentTypes, awPackageDocumentTypes] = await Promise.all([
    GetAWPAttachments(awPackageId),
    GetOrderDocumentTypes(awPackage?.orderFormTypeId),
    GetAWPDocumentTypes(awPackage?.orderFormTypeId)
  ]);

  return new AWPackageAttachmentsView({
    awPackageId,
    editable,
    model: new Backbone.Model({
      documentTypes,
      attachments,
      awPackageDocumentTypes
    })
  });
}
